import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private UserData = new BehaviorSubject<any>('');
  private UserImage = new BehaviorSubject<any>('');
  currentUserData = this.UserData.asObservable();
  currentUserImage = this.UserImage.asObservable();
  constructor(private http:HttpClient) { }
Get_Userprofile(){
  return this.http.get(`${environment.API_Base_URL}`+`User/GetUserByname`)
}
update_profile(data){
  return this.http.put(`${environment.API_Base_URL}`+`User/UpdateUserProfile`,data)
}

changeUserData(data: any) {
  this.UserData.next(data)
}
changeUserImage(image: any) {
  this.UserImage.next(image)
}

}
